export const getFaqData = ({ forSchema = false }: { forSchema: boolean }) => [
  {
    title: "How long is Traqq's free trial?",
    description: "Every paid plan includes a 14-day free trial with full access to its features. No payment details required to start.",
  },
  {
    title: "What payment methods do you support?",
    description: "Payments are processed securely by Paddle. You can pay with major credit and debit cards, PayPal, and selected local payment methods, depending on your country.",
  },
  {
    title: "Can we change plans anytime?",
    description: "Yes. You can change your plan at any time from the Subscription section in your account. You can upgrade or downgrade to any plan except Enterprise directly from your account. To upgrade to Enterprise, contact our team for a custom quote.",
  },
  {
    title: "Can we add or remove users anytime?",
    description: "Yes. You can add or remove users at any time. Additional seats are charged immediately for the remaining billing period. If you reduce your seats, any unused prepaid amount is converted into Credit balance and applied to future payments.",
  },
  {
    title: "Do archived users count toward my plan's user limit?",
    description: "No. Only active users count toward your plan limit. Archived users remain in your workspace but do not count toward your active user limit. Note that your subscription cost is based on the number of purchased seats, not the number of active users.",
  },
  {
    title: "What happens if we downgrade our plan?",
    description: <>
      <span className="block">
        When you downgrade to a lower paid plan, any unused time on your current plan is converted into Credit balance and applied to future payments. You may need to archive users that exceed your new plan limits. Archived users stay in your workspace, and their historical records remain available. Be aware that downgrading may also remove access to certain features available in higher plans.
      </span>
      <span className="block mt-4">
        When switching to the Free plan, your workspace is updated immediately. Any unused time remaining in your current billing period is non-refundable unless you're eligible for the 14-day money-back guarantee on your first purchase. Contact Support to request a refund.
      </span>
    </>,
  },
  {
    title: "Does Traqq offer refunds?",
    description: "We offer a 14-day money-back guarantee for first-time subscriptions if you're not satisfied with the product. After that, subscriptions are non-refundable. If you downgrade to a lower paid plan or reduce the number of seats, any unused prepaid amount is converted into Credit balance and applied to future subscription payments."
  },
  {
    title: "Can I cancel my subscription anytime?",
    description: "Yes. You can cancel your subscription at any time. After cancellation, your paid plan becomes inactive. You can still track time, but all other Traqq features become unavailable. You can purchase a paid plan again or switch to the Free plan. Any unused time remaining in your current plan is non-refundable unless you're eligible for the 14-day money-back guarantee on your first purchase. If you only want to stop automatic renewal, you can pause your subscription instead and continue using paid features until the end of the billing period."
  },
  {
    title: "Can we sign up for the Enterprise plan with fewer than 300 users?",
    description: "The Enterprise plan is available only for organizations with 300 or more users. If your team is slightly smaller but requires custom solutions, get in touch with us to discuss your needs."
  }
]
